import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const apiCatalogPlugin = createPlugin({
  id: 'api-catalog',
  routes: {
    root: rootRouteRef,
  },
});

export const ApiExplorerPage = apiCatalogPlugin.provide(
  createRoutableExtension({
    name: 'ApiExplorerPage',
    component: () => import('./screens').then(m => m.ApiListPage),
    mountPoint: rootRouteRef,
  }),
);

export const ApiGroupLayout = apiCatalogPlugin.provide(
  createRoutableExtension({
    name: 'ApiGroupLayout',
    component: () => import('./components').then(m => m.ApiGroupLayout),
    mountPoint: rootRouteRef,
  }),
);

export const NautilusEntityLayout = apiCatalogPlugin.provide(
  createRoutableExtension({
    name: 'NautilusEntityLayout',
    component: () => import('./components').then(m => m.NautilusEntityLayout),
    mountPoint: rootRouteRef,
  }),
);

export const NewRelicAgent = apiCatalogPlugin.provide(
  createRoutableExtension({
    name: 'NewRelicAgent',
    component: () => import('./components').then(m => m.NewRelicAgent),
    mountPoint: rootRouteRef,
  }),
);

export const ApiCatalogLayout = apiCatalogPlugin.provide(
  createRoutableExtension({
    name: 'NewRelicAgent',
    component: () => import('./components').then(m => m.ApiCatalogLayout),
    mountPoint: rootRouteRef,
  }),
);
